import { useState } from "react";
import { AlertTriangle, Trash2 } from "lucide-react";

/** Typed confirmation for irreversible bulk deletes. Admin dashboard only. */
export default function DeleteAllDialog({ label, count, busy, onCancel, onConfirm, testId = "delete-all" }) {
  const [typed, setTyped] = useState("");
  const armed = typed.trim().toUpperCase() === "DELETE";

  return (
    <div className="fixed inset-0 z-[80] bg-ink/90 backdrop-blur-sm flex items-center justify-center px-6" data-lenis-prevent onClick={onCancel}>
      <div className="w-full max-w-lg bg-ink-800 border border-crimson/50 p-8" onClick={(e) => e.stopPropagation()} data-testid={`${testId}-dialog`}>
        <div className="flex items-start gap-4">
          <AlertTriangle className="w-6 h-6 text-crimson shrink-0 mt-1" />
          <div>
            <h3 className="font-serif text-2xl text-vellum leading-tight">Delete {count} {label}?</h3>
            <p className="mt-3 text-sm text-vellum-muted leading-relaxed">
              This removes every one of them, along with their stored artwork. There is no undo — export a
              backup from Import / Export first if you might want them back.
            </p>
          </div>
        </div>
        <label className="block mt-8">
          <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-vellum-faint">Type DELETE to confirm</span>
          <input
            autoFocus
            value={typed}
            onChange={(e) => setTyped(e.target.value)}
            data-testid={`${testId}-confirm-input`}
            className="mt-2 w-full bg-ink border border-line px-4 py-3 font-mono text-sm tracking-[0.2em] text-vellum focus:border-crimson outline-none"
          />
        </label>
        <div className="mt-8 flex items-center justify-end gap-4">
          <button onClick={onCancel} data-testid={`${testId}-cancel`} className="font-mono text-xs uppercase tracking-[0.2em] px-5 py-3 border border-line text-vellum-muted hover:text-vellum transition-colors">
            Cancel
          </button>
          <button
            onClick={() => onConfirm("DELETE")}
            disabled={!armed || busy}
            data-testid={`${testId}-confirm`}
            className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] px-5 py-3 bg-crimson text-onaccent hover:bg-crimson-hover transition-colors disabled:opacity-30 disabled:cursor-not-allowed"
          >
            <Trash2 className="w-4 h-4" /> {busy ? "Deleting…" : `Delete ${count}`}
          </button>
        </div>
      </div>
    </div>
  );
}
